import React, { Component } from "react";
import Header from "../components/Header.js";
import icon from "../images/icone_page_404.svg";

export class Page404 extends Component {
  render() {
    return (
      <div className="container h-100">
        <Header logo={this.props.logo} />
        <div className="row text-center px-4" style={{ minHeight: "calc(100vh - 106px)" }}>
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-8 offset-xl-2 mt-5">
            <img src={icon} style={{ maxHeight: "105px" }} alt="" className="img-fluid mx-auto d-block mt-4" />
            <h1 className="card-title fw-bold text-white mt-5">PÁGINA NÃO ENCONTRADA</h1>
            <h5 className="card-text text-light mt-5">Verifique se você digitou o endereço correto ou tente clicar no link novamente.</h5>
          </div>
        </div>
      </div>
    );
  }
}

export default Page404;
